"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var baseUrl = 'knowledge-content/v1/knowledge-articles';

var _default = function _default(apiClient) {
  return {
    fetchRenderedContent: function fetchRenderedContent(_ref) {
      var id = _ref.id;
      return apiClient.get(baseUrl, {
        query: {
          id: id
        }
      }).then(function (results) {
        var article = results.objects[0];
        var absoluteUrl = article.absoluteUrl,
            title = article.title;
        return {
          body: title,
          htmlBody: "<a href=" + absoluteUrl + ">" + title + "</p>"
        };
      });
    }
  };
};

exports.default = _default;
module.exports = exports.default;